import * as React from "react";

import { StrategyPineDetailDialog } from "@/components/Strategies/StrategyPineDetailDialog";
import { Button } from "@/components/ui/button";

export type DeleteSimulationDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isDeleting?: boolean;
  onConfirm: () => void;
};

export function DeleteSimulationDialog({
  open,
  onOpenChange,
  isDeleting = false,
  onConfirm,
}: DeleteSimulationDialogProps): React.ReactElement {
  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen && isDeleting) return;
    onOpenChange(nextOpen);
  };

  return (
    <StrategyPineDetailDialog
      open={open}
      onOpenChange={handleOpenChange}
      title="Delete simulation"
      showHeader={false}
      showDismissButton={false}
      showCornerClose={false}
      contentClassName="sm:max-w-md"
      bodyClassName="flex-none overflow-visible pt-0"
      contentProps={{ "data-simulation-delete-dialog": "" }}
      footer={
        <div
          data-dashboard-layout-dialog-footer=""
          className="inline-flex max-w-full flex-wrap items-center justify-end gap-2"
        >
          <Button
            type="button"
            variant="outline-gray"
            size="sm"
            data-font="primary"
            className="shrink-0"
            disabled={isDeleting}
            onClick={() => onOpenChange(false)}
          >
            <span className="normal-case tracking-normal">Cancel</span>
          </Button>
          <Button
            type="button"
            variant="outline"
            size="sm"
            data-font="primary"
            data-trade-log-action="delete"
            className="shrink-0 border-destructive/40 text-destructive shadow-sm hover:bg-destructive/10 hover:text-destructive focus-visible:border-destructive/60 focus-visible:ring-destructive/25 dark:border-destructive/50 dark:hover:bg-destructive/15 [&_svg]:text-current"
            disabled={isDeleting}
            aria-busy={isDeleting || undefined}
            onClick={onConfirm}
          >
            <span data-font="primary" className="normal-case tracking-normal">
              {isDeleting ? "Deleting…" : "Delete simulation"}
            </span>
          </Button>
        </div>
      }
    >
      <p className="font-[family-name:var(--font-primary)] text-sm font-normal text-gray-500 dark:text-sidebar-foreground">
        Delete this simulation permanently? This cannot be undone.
      </p>
    </StrategyPineDetailDialog>
  );
}
